import { Component, OnInit, Input, Output , EventEmitter, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { LoadingService } from '../../../shared/services/loading.service';
import { CollateralService } from '../../../setup/services/collateral.service';
import { AppConstant, GlobalConfig } from '../../../shared/constant/app.constant';
import { CreditAppraisalService, LoanService } from 'app/credit/services';
import swal from 'sweetalert2';

@Component({
    templateUrl: 'collateral-swap.component.html'
})

export class CollateralSwapComponent implements OnInit {
    activeTabindex: number;
    displaySearchForm: boolean = false;
    searchForm:FormGroup;
    applications: any[];
    searchString: any;
    selection: any;
    targetId: any;
    operationId: any;
    rowSelected:boolean;
    requestNumber: any;
    customerName: any;
    level: any;
    status: any;
    mainInsuranceDetail: any={};
    collateralId: any;
    mainInsuranceView: boolean;
    hideGrid: boolean = false;
    customerCollateral: any;
    showBottom: boolean = false;
    insurancePolicy: any;
	insurancePolicies: any;
	reload:number;
	showProposedCollaterals = false;
	selectedRecord: any;
	swapRecord: any;
  
    useSearch: boolean;
    fileDocument: any;
    binaryFile: any;
    selectedDocument: any;
    displayDocument: boolean;
	allRequiredDocumentsAreUploaded = true;
	oldSwapCollateral: any;
	newSwapCollateral: any;
	collateralSwapForm: FormGroup;
	swapForwardForm: FormGroup;
	collateralSwapRequests: any[] = [];
	selectedId: number;
	csForwardForm: FormGroup;
	showCsForward: boolean;
    csForwardTitle = 'Collateral Swap';
	vote: number;
	forwardAction: number;
	showCollateralDetail = false;
	showLoanDetails = false;
	selectedApplicationId = 0;
	collateralToShow: any = {};
  
    constructor(
		private collateralService: CollateralService,
        private loanService: LoanService,
		private creditAppraisalService: CreditAppraisalService,
		private loadingService:LoadingService,
		private fb: FormBuilder
    ) { }
  
    ngOnInit() {
		this.initializeControls();
		this.getCollateralSwapRequests();
    }

	initializeControls() {
		this.resetActiveTabIndex();
		this.clearControls();
	}

    clearControls() {
		this.applications = [];
		this.selectedId = null;
		this.reload = 1;
		this.oldSwapCollateral = {};
		this.newSwapCollateral = {};
		this.searchForm = this.fb.group({
			searchString: ['', Validators.required],
		});
		this.collateralSwapForm = this.fb.group({
			collateralSwapId: '',
			loanCollateralMappingId: ['', Validators.required],
			loanAppCollateralId: ['', Validators.required],
			oldCollateralId: ['', Validators.required],
			newCollateralId: ['', Validators.required],
		});

		this.csForwardForm = this.fb.group({
            forward: [''],
            comment: ['', Validators.required]
        });
	}

	startNewSwapRequest() {
		this.showNextTab();
	}
	
	getCollateralSwapRequests() {
		this.collateralService.getCollateralSwapRequests().subscribe((response: any) => {
			this.collateralSwapRequests = response.result;
		});
	}

	getCollateralSwapRequestsForApproval() {
		this.collateralService.getCollateralSwapRequestsForApproval().subscribe((response: any) => {
			this.collateralSwapRequests = response.result;
		});
	}

	viewSwapInfo(row) {
		this.loadingService.show();
		this.collateralService.getCollateralMappingDetails(row.loanAppCollateralId).subscribe((response: any) => {
			this.loadingService.hide();
			if (response.success == true){
				this.applications = response.result;
				this.showNextTab();
			}
		});
	}
    
    showSearchForm() {this.displaySearchForm=true;}
  
    cancelDetails() { 
      this.showBottom = false;
      this.mainInsuranceView = null;
	}
	
    submitSearch(form) {
		this.searchString = form.value.searchString;
		this.loadingService.show();
		let body = {
			searchString: this.searchString
		}
		this.loanService.approvedLoanApplicationDetailSearch(body).subscribe((response: any) => {
			this.loadingService.hide();
			this.applications = response.result;
			this.displaySearchForm = false;
			this.showBottom = false;
		}, (err: any) => {
			this.loadingService.hide(1000);
		});
	}

	showNextTab() {
		this.activeTabindex += 1;
	}
  
  	viewProposedCollaterals(row) {
		console.log('selected application', row);
		this.selectedRecord = row;
		this.selectedApplicationId = row.loanApplicationId;
		// this.resetActiveTabIndex();
		this.showNextTab();
		// this.showProposedCollaterals = true;
	}

	viewLoanDetail(row){
		this.selectedApplicationId = row.loanApplicationId;
		this.showLoanDetails = true;
	}

	viewCollateralDetail(row){
		this.collateralToShow = row;
		this.showCollateralDetail = true;
	}
  
	onTabChange(event) {
        this.activeTabindex = event.index;
    }
  
	setrequiredUploadValue(value: boolean) {
		this.allRequiredDocumentsAreUploaded = value;
	
	}
  
	isOnApplicationsListTab(): boolean {
        return this.activeTabindex == 0;
    }
	
	resetActiveTabIndex() {
        this.activeTabindex = 0;
        this.activeTabindex = 0;
        this.activeTabindex = 0;
	}
	
	getEmittedCollateral(event) {
		console.log(event);
		this.newSwapCollateral = event;
		this.oldSwapCollateral = event.oldCollateral;
		if (this.oldAndNewCollateralsForSwapAreValid) {
			this.showNextTab();
			this.setCollateralSwapForm();
		}
	}

	oldAndNewCollateralsForSwapAreValid(): boolean {
		return ((this.newSwapCollateral != null && this.newSwapCollateral != undefined) && (this.oldSwapCollateral != null && this.oldSwapCollateral != undefined))
	}

	setCollateralSwapForm() {
		this.collateralSwapForm.patchValue({
			loanCollateralMappingId: this.newSwapCollateral.oldCollateral.loanCollateralMappingId,
			loanAppCollateralId: this.newSwapCollateral.oldCollateral.loanAppCollateralId,
			oldCollateralId: this.newSwapCollateral.oldCollateral.collateralId,
			newCollateralId: this.newSwapCollateral.collateralId
		});
	}

	editCollateralSwapForm(body) {
		this.collateralSwapForm.setValue({
			collateralSwapId: body.collateralSwapId,
			loanCollateralMappingId: body.loanCollateralMappingId,
			loanAppCollateralId: body.loanAppCollateralId,
			oldCollateralId: body.oldSwapCollateral,
			newCollateralId: body.collateralId
		});
	}

	saveCollateralSwapRequest(form = this.collateralSwapForm) {
        form.value.collateralSwapId = this.selectedId;
        console.log(form.value);
		if (!(form.value.collateralSwapId>0)) {
			this.collateralService.saveCollateralSwapRequest(form.value).subscribe((response: any) => {
				this.loadingService.hide();
				if (response.success == true) {
					this.finishGood(response.message);
					// swal(`${GlobalConfig.APPLICATION_NAME}`, 
					// '<br/> The collateral swap request was added successfully<b>' , 'success');
					this.getCollateralSwapRequests();
					// this.getLcUssance(response.result.lcUssanceId);
				}
				else this.finishBad(response.message);
			}, (err: any) => {
				this.loadingService.hide();
				this.finishBad(JSON.stringify(err));
			});
		} else {
			this.collateralService.updateCollateralSwapRequest(form.value, form.value.collateralSwapId).subscribe((response: any) => {
				this.loadingService.hide();
				if (response.success == true) {
					this.finishGood(response.message);
					this.getCollateralSwapRequests();
				// this.reloadGrid();
				}
				else this.finishBad(response.message);
			}, (err: any) => {
				this.loadingService.hide();
				this.finishBad(JSON.stringify(err));
			});
		}
    }

	forward() {
        this.showCsForward = true;
	}

	goForApproval() {
        const __this = this;
            swal({
                title: 'Are you sure?',
                text: 'You want to submit?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No, cancel!',
                confirmButtonClass: 'btn btn-success btn-move',
                cancelButtonClass: 'btn btn-danger',
                buttonsStyling: true,
            }).then(function () {
                __this.loadingService.show();
            // if (__this.lcForwardForm.controls['forward'].value == 2) {
            //     if (__this.privilege.canApprove == true) {
            //         __this.vote = __this.lcForwardForm.controls['forward'].value;
            //         __this.forwardAction = __this.lcForwardForm.controls['forward'].value;
            //     } else {
            //         __this.vote = __this.lcForwardForm.controls['forward'].value;
            //         __this.forwardAction = 0;
            //     }
            // } else {
            //     __this.vote = __this.lcForwardForm.controls['forward'].value;
            //     __this.forwardAction = __this.lcForwardForm.controls['forward'].value;
            // }
            __this.vote = 1;
            __this.forwardAction = 0;
                
            let body = {
                    forwardAction: __this.forwardAction,
                    comment: __this.csForwardForm.controls['comment'].value,
                    collateralSwapId: __this.selectedId,
                    // d,receiverLevelId: this.lcSelection.currentApprovalLevelId, // refer back
                    // receiverStaffId: this.lcSelection.toStaffI // refer back
                    vote: __this.vote,
                };
					__this.collateralService.forwardForCollateralSwap(body)
							.subscribe((res: any) => {
								__this.loadingService.hide();
								if (res.success === true) {
									__this.getCollateralSwapRequests();
									__this.initializeControls();
									__this.showCsForward = false;
										swal(`${GlobalConfig.APPLICATION_NAME}`, 
										'<br/> ' + res.message , 'success');
								} else {
									__this.showCsForward = false;
									swal(`${GlobalConfig.APPLICATION_NAME}`, res.message, 'error');
									__this.loadingService.hide();
								}
							}, (err) => {
								__this.showCsForward = false;
								__this.loadingService.hide();
								swal(`${GlobalConfig.APPLICATION_NAME}`, JSON.stringify(err), 'error');
							});
            }, function (dismiss) {
                if (dismiss === 'cancel') {
                    swal(`${GlobalConfig.APPLICATION_NAME}`, 'Operation cancelled', 'error');
                }
            });
    }
	

	// ---------------------- message ----------------------

	show: boolean = false; message: any; title: any; cssClass: any;

	finishGood(message) { 
	  this.showMessage(message, 'success', "FintrakBanking");
	  this.loadingService.hide(); }
  
	hideMessage(event) { this.show = false; }
  
	finishBad(message) {
		this.showMessage(message, 'error', "FintrakBanking");
		this.loadingService.hide();
	}
  
	showMessage(message: string, cssClass: string, title: string) {
		this.message = message;
		this.title = title;
		this.cssClass = cssClass;
		this.show = true;
	}
}
  

